import { Nav } from "@/components/Nav";
import { Seo } from "@/components/Seo";
import { Hero } from "@/components/Hero";
import { ImpactStats } from "@/components/ImpactStats";
import { Marquee } from "@/components/Marquee";
import { Journeys } from "@/components/Journeys";
import { JourneyQuiz } from "@/components/JourneyQuiz";
import { Destinations } from "@/components/Destinations";
import { Experiences } from "@/components/Experiences";
import { Services } from "@/components/Services";
import { Journal } from "@/components/Journal";
import { Testimonials } from "@/components/Testimonials";
import { SocialSection } from "@/components/SocialSection";
import { Community } from "@/components/Community";
import { Concierge } from "@/components/Concierge";
import { Footer } from "@/components/Footer";
import { FeaturedSales, VipArrival, ShopPreview, ConsultStrip } from "@/components/HomeSales";
import { WhatWeDo } from "@/components/WhatWeDo";
import { StartConversation } from "@/components/StartConversation";
import { Founder } from "@/components/Founder";

export default function Home() {
  return (
    <div data-testid="jawa-home" className="bg-jawa-ivory">
      <Nav />
      <Seo
        title="JÀWÀ Africa — Your Return to Africa, Made Easier."
        description="Premium African lifestyle, travel, relocation and investment platform — A–Z guides, VIP arrival experiences, memberships, consultations and a personal concierge."
      />
      <main>
        <Hero />
        <Marquee />
        <WhatWeDo />
        <ImpactStats />
        <Journeys />
        <JourneyQuiz />
        <Services />
        <VipArrival />
        <Experiences />
        <Destinations />
        <FeaturedSales />
        <ShopPreview />
        <Concierge />
        <ConsultStrip />
        <Testimonials />
        <Journal />
        <Founder />
        <StartConversation />
        <Community />
        <SocialSection />
      </main>
      <Footer />
    </div>
  );
}
